module.exports = __webpack_public_path__ + "img/down_arrow.1ee7ab02.svg";